import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoading: false,
  vacsEmpLength: 0,
  vacsEmp: [],
}

export default function vaccinesEmpReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_VACCINES_EMP:
      return {...state, loading: action.payload }
    case actions.SAVE_LOADING_VACCINES_EMP:
      return {...state, saveLoading: action.payload }
    case actions.GET_VACCINES_EMP:
      return {...state, vacsEmp: action.payload.vacsEmp, vacsEmpLength: action.payload.vacsEmpLength}
    default:
      return state
  }
}